const isProduct = true;
const buff = isProduct ? 'pro' : 'dev';

const basicUrl = !isProduct ? 'http://127.0.0.1:7000' : 'http://powerapi.lerisktech.com';

const api = {
    
    // 登录接口 成功返回token 和用户信息
    login: `${basicUrl}/agent/login`,

    //验证码
    getVerify:             `${basicUrl}/user/getVerify`,
    checkVerify:           `${basicUrl}/user/checkVerify`,
    modifyUserType:        `${basicUrl}/user/modifyUserType`,

    //获取所有代理商 添加账号 停用 授权角色
    getAllAuthAgent:     `${basicUrl}/agent/getAllAuthAgent`,
    getAllAuthAgentPage: `${basicUrl}/agent/getAllAuthAgentPage`,
    saveAuthAgent:       `${basicUrl}/agent/saveAuthAgent`,
    stopAuthAgent:       `${basicUrl}/agent/stopAuthAgent`,
    giveRole:            `${basicUrl}/agent/giveRole`,
    modifyAuthAgent:     `${basicUrl}/agent/modifyAuthAgent`,

    //查询所有角色  修改角色  删除角色
    getAllAuthRole:         `${basicUrl}/agent/getAllAuthRole`,
    getAllAuthRoleTrue:     `${basicUrl}/agent/getAllAuthRoleTrue`,
    modifyAuthRole:         `${basicUrl}/agent/modifyAuthRole`,
    removeAuthRole:           `${basicUrl}/agent/stopAuthRole`,
    getAllAuthAgentByRoleId:  `${basicUrl}/agent/getAllAuthAgentByRoleId`,
    modifyPassword:           `${basicUrl}/agent/modifyPassword`,

    //查询微信 支付宝用户信息
    getAllUserInfo:      `${basicUrl}/user/getAllUserInfo`,

    //查询所有菜单
    getAllAuthMenu:      `${basicUrl}/agent/getAllMenu`,
    getMenuByParentId:   `${basicUrl}/agent/getMenuByParentId`,
    saveAuthMenu:        `${basicUrl}/agent/saveAuthMenu`,
    deleteAuthMenu:      `${basicUrl}/agent/deleteAuthMenu`,
    getMenuByRoleId:     `${basicUrl}/agent/getMenuByRoleId`,

    //设备查询 修改计费  商户绑定
    getAllEquipment:     `${basicUrl}/equipment/getAllEquipment`,
    getAllMerchant:      `${basicUrl}/equipment/getAllMerchant`,
    modifyEquipment:     `${basicUrl}/equipment/modifyEquipment`,
    modifyEquipmentDeposit:`${basicUrl}/equipment/modifyEquipmentDeposit`,
    bindMerchant:        `${basicUrl}/equipment/bindMerchant`,
    bindTime:            `${basicUrl}/equipment/bindTime`,
    popupEquipmentOnly:  `${basicUrl}/equipment/popupEquipmentOnly`,
    popupEquipmentAll:     `${basicUrl}/equipment/popupEquipmentAll`,
    accountingEquipment:   `${basicUrl}/equipment/accountingEquipment`,
    isSupportDeposit:   `${basicUrl}/equipment/isSupportDeposit`,


    //会员卡查询
    getMemberCard:        `${basicUrl}/user/getMemberCard`,
    modifyCard:           `${basicUrl}/user/modifyCard`,
    getMemberCardRecord:  `${basicUrl}/user/getAllMemberCardRecord`,

    //订单查询 查询今天订单 结束订单 订单统计
    getOrders:            `${basicUrl}/order/getOrders`,
    getOrdersExcel:       `${basicUrl}/order/getOrdersExcel`,
    getTodayOrders:       `${basicUrl}/order/getTodayOrders`,
    stopOrder:            `${basicUrl}/order/stopOrder`,
    accountingOrder:      `${basicUrl}/order/accountingOrder`,
    getWeekOrders:          `${basicUrl}/order/getWeekOrders`,
    getMonthOrders:          `${basicUrl}/order/getMonthOrders`,
    //预授权订单管理
    freezeSearch:          `${basicUrl}/freeze/alipay/search`,
    unFreeze:              `${basicUrl}/freeze/alipay/unFreeze`,
    tradePay:              `${basicUrl}/freeze/alipay/tradePay`,

    freezeSearchWx:        `${basicUrl}/freeze/wx/search`,
    tradePayWx:            `${basicUrl}/freeze/wx/completePayScoreOrder`,
    cancelServiceOrder:    `${basicUrl}/freeze/wx/cancelServiceOrder`,

    getOrdersCustomer:     `${basicUrl}/order/getOrdersCustomer`,
    getOrdersCustomerHide: `${basicUrl}/order/getOrdersCustomerHide`,  // 漏
    getOrdersExcelCustomerHide:       `${basicUrl}/order/getOrdersExcelCustomerHide`, // 漏
    setCustomerOrder:      `${basicUrl}/order/setCustomerOrder`,
    setCustomerOrderAll:      `${basicUrl}/order/setCustomerOrderAll`,
    
    //代理商提现
    getAgentCashRequestProgress:    `${basicUrl}/agent-cash/getAgentCashRequestProgress`,
    getAgentCashRequestRefuse:      `${basicUrl}/agent-cash/getAgentCashRequestRefuse`,
    getAgentCashRequestAgree:       `${basicUrl}/agent-cash/getAgentCashRequestAgree`,
    agreeAgentCashRequest:        `${basicUrl}/agent-cash/agreeAgentCashRequest`,
    refuseAgentCashRequest:       `${basicUrl}/agent-cash/refuseAgentCashRequest`,

}

export {
    isProduct,
    buff,
    api
}


// WEBPACK FOOTER //
// ./src/api/api.js